import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Settings for pay statistics calculations.
 * @example
 * ```html
 * <salaxy-pay-stats-settings></salaxy-pay-stats-settings>
 * ```
 */

export class PayStatsSettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {};

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/PayStatsSettings.html";

}
